export enum SUBMISSION_STATUS {
    SUCCESS,
    FAILURE,
    PENDING,
}
